

































































import { ApiClient } from "@/api/client";
import { Component, Vue } from "vue-property-decorator";
import { UserAccount } from "@/interfaces/user";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState(["user"])
  }
})
export default class AgeVerification extends Vue {
  // Mapped from Vuex
  user!: UserAccount;

  // Other variables
  api: ApiClient = new ApiClient();

  sofort = {
    sofortIdentAllowed: false,
    sofortIdentLink: "",
    loading: true
  };

  mounted() {
    if (this.user.sofortident_success === null) {
      this.sofort.sofortIdentAllowed = true;
      this.api.getSofortIdentLink().then((link: string) => {
        this.sofort.sofortIdentLink = link;
        this.sofort.loading = false;
      });
    } else {
      this.sofort.loading = false;
    }
  }
}
